import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import { Box } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import PriceExplanation from "../components/Views/PriceExplanation.jsx";
import sortBy from "lodash/sortBy";

class PriceExplanationContainer extends Container {
    constructor(props) {
        super(props);
        this.getAuxData();
        this.state = { ...this.state, loadAfterChangedByRule: false };
    }

    render = () => {
        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        const { history } = this.props;
        const auxDataRoomTypes =
            this.props?.auxData?.room_types &&
            this.props.auxData.room_types.filter((t) => t.active);
        const sortedRoomTypes = sortBy(auxDataRoomTypes, "order");
        const auxDataRates =
            this.props?.auxData?.rates_short && this.props.auxData.rates_short;

        const priceExplanation =
            !auxDataRoomTypes || !auxDataRates ? (
                <Box mt={4}>
                    <LinearProgress mt={3} />
                </Box>
            ) : (
                <Box p={3}>
                    <PriceExplanation
                        loading={this.state.loading}
                        rates={auxDataRates}
                        roomTypes={sortedRoomTypes}
                        history={history}
                        openLeftMenu={this.props.openLeftMenu}
                        hotelId={this.props.match.params.mainId}
                    />
                </Box>
            );

        return (
            <Paper elevation={3}>
                <Box p={3}>
                    <Typography mb={3} variant={"h5"}>
                        Толкование цен
                    </Typography>
                </Box>
                {priceExplanation}
            </Paper>
        );
    };
}

export default PriceExplanationContainer;
